import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Popper } from '@mui/material';
import { debounce } from 'lodash';
import axios from 'axios';
import { Images, renderClientName, renderStaffName } from 'utils';
import { CLIENT_BASIC_SEARCH_URL, clientSearchKeys, toSearchBody } from 'utils/clientSearch';
import { MinLoader, TextRow } from 'components';
import { leftBarCommonStyle } from './styles';
import ClearIcon from '@mui/icons-material/Clear';
export const SearchFromSystem = ({}) => {
    const { handleSubmit } = useForm({});
    const classes = leftBarCommonStyle();
    const location = useLocation();
    const searchInputRef = useRef();
    const [load, setLoad] = useState(false);
    const navigate = useNavigate();
    const info = location?.state;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;
    const ITEMS_PER_PAGE = 50;
    const page = 1;
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState(null);
    const originalPath = location?.pathname?.split('/')[1];

    useEffect(() => {
        setAnchorEl(null);
        setValue(null);
    }, [location?.pathname]);

    const renderSearchInfo = () => {
        if (location?.pathname === '/fundingSource' || originalPath === 'fundingSource') {
            return {
                name: 'Payer',
                placeholder: 'Search by Payer Name',
                link: '/funding',
                searchKey: 'NAME',
                sortType: 'name',
                renderName: (i) => i?.name,
                url: (id) => `/fundingSource/${id}`,
            };
        }
        if (location?.pathname === '/staff' || originalPath === 'staff') {
            return {
                name: 'Staff',
                placeholder: 'Search by Staff Name',
                link: '/staff/basic/info',
                searchKey: 'NAME',
                sortType: 'fullName',
                renderName: (i) => renderStaffName(i),
                url: (id) => `/staff/${id}`,
            };
        }
        if (location?.pathname === '/client' || originalPath === 'client') {
            return {
                name: 'Client',
                placeholder: 'Search by Client name or code',
                link: CLIENT_BASIC_SEARCH_URL,
                searchKey: clientSearchKeys.ANY,
                sortType: 'code',
                renderName: (i) => renderClientName(i),
                url: (id) => `/client/${id}`,
            };
        }
    };

    const handleChange = (e) => {
        if (e.target.value.startsWith(' ')) {
            return;
        }
        setValue(e.target.value);
    };

    const openAnchor = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const fetchOptions = useCallback(
        debounce(async (page, searchTerm) => {
            try {
                setLoad(true);
                const apiUrl = renderSearchInfo()?.link;

                const params = {
                    skip: (page - 1) * ITEMS_PER_PAGE,
                    limit: ITEMS_PER_PAGE,
                    // searchValue: searchTerm || undefined,
                    // searchKey: renderSearchInfo()?.searchKey || undefined,
                    sortType: renderSearchInfo()?.sortType || undefined,
                    orderType: 'ASC',
                };

                if (searchTerm) {
                    params.searchValue = searchTerm;
                    params.searchKey = renderSearchInfo()?.searchKey || undefined;
                } else {
                    delete params.searchValue;
                    delete params.searchKey;
                }
                // Client search text is PHI — it goes in a POST body, never the URL.
                const response =
                    renderSearchInfo()?.name === 'Client'
                        ? await axios.post(apiUrl, toSearchBody(params), { auth: true })
                        : await axios.get(apiUrl, {
                              params,
                              auth: true,
                          });

                const data = renderSearchInfo()?.name === 'Payer' ? response?.data?.funders : response?.data || [];
                setOptions((prevOptions) => (page === 1 ? [...data] : [...prevOptions, ...data]));
            } catch (error) {
                console.error('Error fetching options:', error);
            } finally {
                setLoad(false);
            }
        }, 300),
        [renderSearchInfo()?.name]
    );

    useEffect(() => {
        fetchOptions(page, value, info);
    }, [page, value, fetchOptions]);

    return (
        <div className="search-from-system-wrapper">
            <form onSubmit={handleSubmit(() => {})}>
                <div className={classes.searchInputBoxStyle} onClick={(e) => openAnchor(e)}>
                    <input
                        ref={searchInputRef}
                        value={value ? value : ''}
                        onChange={(e) => handleChange(e)}
                        placeholder={renderSearchInfo()?.placeholder}
                        autoComplete={'off'}
                    />
                    {value && (
                        <button
                            className="remove-value-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setValue(null);
                            }}
                        >
                            <ClearIcon />
                        </button>
                    )}
                    <button className={classes.searchButtonStyle}>
                        {load ? (
                            <MinLoader small={true} margin={'0'} color={'#344054'} position="relative" />
                        ) : (
                            <img src={Images.searchIcon} alt="" />
                        )}
                    </button>
                </div>
            </form>

            <Popper
                id={id}
                open={open}
                anchorEl={anchorEl}
                className={'searched-list-wrapper'}
                placement="bottom-start"
                style={{ position: 'absolute', zIndex: 1400 }}
            >
                <div className="searched-items-box">
                    {load ? (
                        <p className="search-info-text">Loading...</p>
                    ) : options?.length ? (
                        options?.map((i, j) => (
                            <button
                                key={j}
                                className="searched-item-btn"
                                onClick={() => {
                                    setAnchorEl(null);
                                    setValue(renderSearchInfo()?.renderName(i));
                                    // navigate(renderSearchInfo()?.url(i?.id))
                                    window.open(renderSearchInfo()?.url(i?.id), '_self');
                                }}
                            >
                                <TextRow name={renderSearchInfo()?.renderName(i)} />
                            </button>
                        ))
                    ) : (
                        <p className="search-info-text">No Options Yet</p>
                    )}
                </div>
            </Popper>
            {open && <div className="beck-drop" onClick={() => setAnchorEl(null)} />}
        </div>
    );
};
